import { useState } from 'react'

import PropTypes from 'prop-types'

import useSnackbar from 'hooks/useSnackbar'

import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Typography,
} from '@material-ui/core'
import { LoadingButton } from 'components'

import * as service from 'service'

import useStyles from './styles'

const FaqInactiveOrActiveDialog = ({ faq, open, setOpen, refresh }) => {
  const classes = useStyles()
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()

  const InactiveOrActive = async () => {
    setLoading(true)
    try {
      if (faq?.active) {
        await service.dponet.faqsDocumentations.put({
          faqsDocumentationId: faq?.id,
          active: false,
        })
      } else {
        await service.dponet.faqsDocumentations.put({
          faqsDocumentationId: faq?.id,
          active: true,
        })
      }
      refresh()
      snackbar.open({
        message: `FAQ ${faq?.active ? 'inativada' : 'ativada'}com sucesso`,
        variant: 'success',
      })
    } catch {
      snackbar.open({
        message: `Falha ao inativar FAQ`,
        variant: 'error',
      })
    }
    setOpen(false)
    setLoading(false)
    refresh()
  }

  const noticeText = () => {
    if (faq?.active) {
      return (
        <Box pb={1}>
          <Typography className={classes.textColor}>
            Tem certeza que deseja inativar?
          </Typography>
          <Typography className={classes.text}>
            Se inativada, ela não será mais vísivel para os clientes
          </Typography>
        </Box>
      )
    }

    return (
      <Box pb={1} className={classes.text}>
        <Typography className={classes.textColor}>
          Tem certeza que deseja reativar?
        </Typography>
        <Typography className={classes.text}>
          Se reativada, ela será vísivel para os clientes
        </Typography>
      </Box>
    )
  }

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="change-last-update-status"
      fullWidth
    >
      <DialogTitle disableTypography>
        <Typography className={classes.textTitle}>
          {`TEM CERTEZA QUE DESEJA ${
            faq?.active ? 'INATIVAR' : 'REATIVAR'
          } ESSA FAQ?`}
        </Typography>
      </DialogTitle>
      <Divider />
      <Box>
        <DialogContent>{noticeText()}</DialogContent>
      </Box>
      <Divider />
      <DialogActions p={2}>
        <Box pl={2} pr={1}>
          <Button
            type="button"
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Cancelar
          </Button>
        </Box>
        <LoadingButton
          variant="contained"
          type="submit"
          color="primary"
          text={faq?.active ? 'INATIVAR' : 'ATIVAR'}
          loading={loading}
          onClick={InactiveOrActive}
        />
      </DialogActions>
    </Dialog>
  )
}

FaqInactiveOrActiveDialog.propTypes = {
  faq: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  refresh: PropTypes.func.isRequired,
}

FaqInactiveOrActiveDialog.defaultProps = {
  faq: {},
  setOpen: () => {},
  refresh: () => {},
}

export default FaqInactiveOrActiveDialog
